var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 44.556962,
    cy: 44.556962,
    r: 3.03797468
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.063291, -5.063291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.075949, 7.088608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9910926,0 C19.0442982,0 2.02531646,17.0203126 2.02531646,37.9694047 C2.02531646,58.9118983 19.0442982,75.9493671 39.9910926,75.9493671 C60.9385469,75.9493671 77.9746835,58.9118983 77.9746835,37.9694047 C77.9746835,17.0203126 60.9385469,0 39.9910926,0 M39.9910926,65.2187971 C22.9721109,65.2187971 9.16703387,51.4297969 9.16703387,34.3976069 C9.16703387,17.3601381 22.9721109,3.57113792 39.9910926,3.57113792 C57.0278891,3.57113792 70.8158112,17.3601381 70.8158112,34.3976069 C70.8158112,51.4297969 57.0278891,65.2187971 39.9910926,65.2187971",
    id: "Fill-28-Copy",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#FFFFFF",
    cx: 37.4683544,
    cy: 36.4556962,
    r: 33.4177215
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#FFFFFF",
    cx: 33.4177215,
    cy: 36.4556962,
    r: 33.4177215
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1898734,13.7059617 C20.9966474,8.34966417 28.8476465,5.06329114 37.4903195,5.06329114 C55.3750156,5.06329114 69.8734177,19.1386376 69.8734177,36.5024593 C69.8734177,45.1850708 66.2493417,53.0450381 60.3887171,58.7341772",
    id: "Fill-50-Copy-5",
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    transform: "translate(40.872865, 34.134790) rotate(-21.000000) translate(-40.872865, -34.134790) ",
    x: 40.3665363,
    y: 23.4512457,
    width: 1,
    height: 21.367089,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    transform: "translate(52.465528, 44.105617) rotate(-270.000000) translate(-52.465528, -44.105617) ",
    x: 51.9591985,
    y: 35.953718,
    width: 1,
    height: 16.3037979,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.151899, 12.151899)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    transform: "translate(31.898734, 3.544304) scale(-1, 1) translate(-31.898734, -3.544304) ",
    x: 31.8924051,
    y: 0.5,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    transform: "translate(31.898734, 60.253165) scale(-1, 1) translate(-31.898734, -60.253165) ",
    x: 31.8924051,
    y: 57.2088608,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(31.898734, 31.898734) rotate(-270.000000) translate(-31.898734, -31.898734) translate(31.392405, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-2",
    transform: "translate(0.506329, 3.544304) scale(-1, 1) translate(-0.506329, -3.544304) ",
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-3",
    transform: "translate(0.506329, 60.253165) scale(-1, 1) translate(-0.506329, -60.253165) ",
    x: 0.5,
    y: 57.2088608,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(44.050633, 44.050633) rotate(-30.000000) translate(-44.050633, -44.050633) translate(12.151899, 12.151899)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    transform: "translate(31.898734, 3.544304) scale(-1, 1) translate(-31.898734, -3.544304) ",
    x: 31.8924051,
    y: 0.5,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    transform: "translate(31.898734, 60.253165) scale(-1, 1) translate(-31.898734, -60.253165) ",
    x: 31.8924051,
    y: 57.2088608,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(31.898734, 31.898734) rotate(-270.000000) translate(-31.898734, -31.898734) translate(31.392405, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-2",
    transform: "translate(0.506329, 3.544304) scale(-1, 1) translate(-0.506329, -3.544304) ",
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-3",
    transform: "translate(0.506329, 60.253165) scale(-1, 1) translate(-0.506329, -60.253165) ",
    x: 0.5,
    y: 57.2088608,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(44.050633, 44.050633) rotate(-60.000000) translate(-44.050633, -44.050633) translate(12.151899, 12.151899)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    transform: "translate(31.898734, 3.544304) scale(-1, 1) translate(-31.898734, -3.544304) ",
    x: 31.8924051,
    y: 0.5,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    transform: "translate(31.898734, 60.253165) scale(-1, 1) translate(-31.898734, -60.253165) ",
    x: 31.8924051,
    y: 57.2088608,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(31.898734, 31.898734) rotate(-270.000000) translate(-31.898734, -31.898734) translate(31.392405, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-2",
    transform: "translate(0.506329, 3.544304) scale(-1, 1) translate(-0.506329, -3.544304) ",
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-3",
    transform: "translate(0.506329, 60.253165) scale(-1, 1) translate(-0.506329, -60.253165) ",
    x: 0.5,
    y: 57.2088608,
    width: 1,
    height: 6.08860759,
    rx: 0.5
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M44.0417256,6.07594937 C23.0949312,6.07594937 6.07594937,23.1095704 6.07594937,44.0539314 C6.07594937,64.9916954 23.0949312,82.0253165 44.0417256,82.0253165 C64.9891798,82.0253165 82.0253165,64.9916954 82.0253165,44.0539314 C82.0253165,23.1095704 64.9891798,6.07594937 44.0417256,6.07594937 M44.0417256,74.868161 C27.0227438,74.868161 13.2176668,61.0816151 13.2176668,44.0539314 C13.2176668,27.0203104 27.0227438,13.2337646 44.0417256,13.2337646 C61.0785221,13.2337646 74.8664441,27.0203104 74.8664441,44.0539314 C74.8664441,61.0816151 61.0785221,74.868161 44.0417256,74.868161",
    id: "Fill-31-Copy",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-2-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#A6A6A6",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#A6A6A6",
    strokeWidth: 1,
    cx: 44.556962,
    cy: 44.556962,
    r: 2.53797468
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    stroke: "#7F7F7F",
    transform: "translate(35.949367, 51.645570) rotate(229.000000) translate(-35.949367, -51.645570) ",
    x: 35.943038,
    y: 35.943038,
    width: 1,
    height: 31.4050633,
    rx: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationLogo);
export default __webpack_public_path__ + "static/media/NotificationLogo.6301dea972478e56da123807df5187bb.svg";
export { ForwardRef as ReactComponent };